import { Injectable, Optional } from '@angular/core';
import { EMPTY, empty, of } from 'rxjs';
import { BindingList, CommandContext, FrameContext, ViewModel } from '@farris/devkit';
import { FormMessageService } from './form-message.service';
import { FormNotifyService } from './form-notify.service';
import { LanguageService } from './languag.service';

/**
 * æ°æ®æ£æ¥æå¡
 */
@Injectable()
class DataCheckService {
  constructor(
    private messageService: FormMessageService,
    private formNotifyService: FormNotifyService,
    @Optional() private languageService: LanguageService,
    @Optional() private viewModel: ViewModel,
    private frameContext: FrameContext
  ) {
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }
  public checkBeforeAdd(failMessage?: string) {
    if (!this.viewModel) {
      return of(true);
    }
    const bindingPaths = this.viewModel.bindingPath.split('/').filter((p) => p);
    if (bindingPaths.length < 1) {
      return of(true);
    }
    const parentPaths = bindingPaths.slice(0, bindingPaths.length - 1);
    const parentBindingList = this.viewModel.bindingData.getValue(parentPaths) as BindingList;
    const parentCurrentId = parentBindingList.currentId;
    if (!parentCurrentId) {
      if (failMessage && failMessage.trim()) {
        let showMessage: boolean = true;
        if (failMessage.startsWith('{') && failMessage.endsWith('}')) {
          try {
            const options = JSON.parse(failMessage);
            if (options.showMessage === false) {
              showMessage = false;
            }
          } catch { }
        }
        if (showMessage !== false) {
          this.formNotifyService.warning(failMessage, { hideTitle: true });
        }
      } else {
        this.formNotifyService.warning(this.languageService.noParentData, { hideTitle: true });
      }
      return EMPTY;
    }
    return of(true);
  }
  /**
   * ç¼è¾åæ£æ¥
   */
  public checkBeforeEdit(idToEdit: string): any {
    const ifSkipCheck = this.ifSkipCheck(idToEdit);
    if (ifSkipCheck === true) {
      return true;
    }

    if (idToEdit) {
      return true;
    }

    this.formNotifyService.warning(this.languageService.plsSelectEditData, { hideTitle: true });
    return empty();
  }
  /**
   * æ¥çåæ£æ¥
   */
  public checkBeforeView(idToView: string): any {
    const ifSkipCheck = this.ifSkipCheck(idToView);
    if (ifSkipCheck === true) {
      return true;
    }

    if (idToView) {
      return true;
    }

    this.formNotifyService.warning(this.languageService.plsSelectViewData, { hideTitle: true });
    return empty();
  }
  /**
   * èè¡¨åè·³è¿æ£æ¥
   * @todoï¼å¾å é¤ï¼å¼å®¹èè¡¨å
   */
  public ifSkipCheck(id: string): boolean {
    const context = this['context'] as CommandContext;
    const params = context.command.params;

    // è¡¨åæ²¡æéæ°ä¿å­è¿çæåµ
    if (params.hasOwnProperty('idToEdit') === false && params.hasOwnProperty('idToView') === false) {
      return true;
    }

    // ä¿å­è¿ä½æ²¡æå¡«åæ°çæåµ
    // @todo: ä¼æ¼æç©ºä¸²çæåµï¼ç®åä¸»é®è§£æçè¿åå¼æ¯undefinedï¼æä¸èèç©ºä¸²åºæ¯
    if (id === '') {
      return true;
    }

    return false;
  }
}

export { DataCheckService };
